export default "__VITE_ASSET__C1brs3Ng__"